import { Text, View } from '@react-pdf/renderer';
import { createColumnHelper } from '@tanstack/react-table';

import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';
import { commonStyles } from 'src/common/pdf/common.styles';
import { PDFTable } from 'src/common/pdf/PDFTable/PDFTable';

import { InvoiceExportCondensedReportRow } from '../../types';

const createColumn = createColumnHelper<InvoiceExportCondensedReportRow>();
const columns = [
  createColumn.display({
    id: 'description',
    header() {
      return <Text>Description</Text>;
    },
    cell: ({ row }) => {
      return (
        <Text style={commonStyles.textSm}>{row.original.ItemDescription}</Text>
      );
    },
  }),
  createColumn.display({
    id: 'amount_cents',
    header() {
      return <Text>Amount</Text>;
    },
    cell: ({ row }) => {
      return (
        <Text style={commonStyles.textSm}>
          {defaultCurrencyFormat(row.original.ItemAmount)}
        </Text>
      );
    },
  }),
];

interface InvoicePDFTripModifierTableProps {
  rows: InvoiceExportCondensedReportRow[];
}

export function InvoicePDFTripModifierTable({
  rows,
}: InvoicePDFTripModifierTableProps) {
  // Rows should already be filtered, but just in case
  const visibleRows = rows.filter((r) => r.LineItemType !== 'trip');
  return (
    <View style={{ paddingVertical: 4 }}>
      <Text style={[commonStyles.textMd, { color: '#71717a', marginTop: 2 }]}>
        Line Item Modifiers Table
      </Text>
      <PDFTable columns={columns} data={visibleRows} />
      <View style={commonStyles.separatorSm} />
    </View>
  );
}
